<template>
  <div
    id="modal-block-action"
    class="container-modal-block-action"
  >
    <div class="input-search">
      <i class="fa fa-search" />
      <input
        v-model="searchAction"
        type="text"
        placeholder="Search"
        autocomplete="off"
      >
    </div>

    <div
      v-if="listActionSearch.length || searchAction && searchAction.length >= 3"
      class="container-list-action">
      <div
        v-for="(item, index) in listActionSearch"
        :key="index"
        class="container-list-action__items"
        @click="selectActionBlock(item)"
      >
        <div class="d-flex align-items-center">
          <img
            :src="require(`@/assets/automation/${item.icon}.svg`)"
            width="25"
            height="25"
            class="m__r--5">
          <div v-if="item.description">
            <div class="container-list-action__items-name">{{ item.name }}</div>
            <div class="container-list-action__items-description">{{ item.description }}</div>
          </div>
          <div
            v-else
            class="container-list-action__items-name">{{ item.name }}</div>
        </div>
        <i
          v-if="item.childs.length"
          class="fa fa-chevron-right" />

        <div
          v-if="item.childs.length"
          class="container-list-action__items-childs"
        >
          <div class="container-list-action__group-label">
            {{ item.name.toUpperCase() }}
          </div>
          <div
            v-for="(child, indexChilds) in item.childs"
            :key="indexChilds"
            class="container-list-action__childs-name"
            @click="selectActionBlock(item, child)"
          >
            {{ child }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      id="list-action"
      class="container-list-action">
      <div
        v-for="(item, index) in listAction"
        :key="index"
        class="container-list-action__group"
      >
        <div
          v-if="item.group_name !== 'GENERAL'"
          class="container-list-action__group-label">
          {{ item.group_name }}
        </div>
        <div
          v-for="(items, indexItem) in item.items"
          :key="indexItem"
          class="container-list-action__items"
          @click="selectActionBlock(items)"
        >
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/automation/${items.icon}.svg`)"
              width="25"
              height="25"
              class="m__r--5">
            <div v-if="items.description">
              <div class="container-list-action__items-name">{{ items.name }}</div>
              <div class="container-list-action__items-description">{{ items.description }}</div>
            </div>
            <div
              v-else
              class="container-list-action__items-name">{{ items.name }}</div>
          </div>
          <i
            v-if="items.childs.length"
            class="fa fa-chevron-right" />

          <div
            v-if="items.childs.length"
            :id="`items-childs-${items.icon}`"
            class="container-list-action__items-childs"
          >
            <div class="container-list-action__group-label">
              {{ items.name.toUpperCase() }}
            </div>
            <div
              v-for="(child, indexChilds) in items.childs"
              :key="indexChilds"
              class="container-list-action__childs-name"
              @click="selectActionBlock(items, child)"
            >
              {{ child }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ModalListAction',
  props: {
    lastIndex: {
      type: Number,
      default: 0,
    },
    modalRef: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModalBlockAction: false,
      searchAction: null,
      listActionSearch: [],
      listAction: [
        {
          group_name: 'GENERAL',
          items: [
            {
              name: 'Conditional',
              description: 'Run different actions based off a certain condition',
              icon: 'conditional-color',
              type: 'conditional',
              childs: [],
            },
            {
              name: 'While',
              description: 'Run the same actions on every item in a list',
              icon: 'while-color',
              type: 'while',
              childs: [],
            },
            {
              name: 'Script',
              description: 'Run the javascript code',
              icon: 'script-color',
              type: 'javascript',
              childs: [],
            },
          ],
        },
        {
          group_name: 'DATABASE & CONNECTIVITY',
          items: [
            {
              name: 'Data Manager',
              description: '',
              icon: 'data-manager-color',
              type: 'action',
              childs: [
                'Create Record',
                'Create Records',
                'Update Record',
                'Delete Record',
                'Find Record',
                'Find Records',
              ],
            },
            {
              name: 'Big Data Engine',
              description: '',
              icon: 'joana-color',
              type: 'action',
              childs: [
                'Create Record',
                'Create Records',
                'Update Record',
                'Find Record',
                'Find Records',
                'Execute Query',
              ],
            },
            {
              name: 'Data Connectivity',
              description: '',
              icon: 'data-connectivity-color',
              type: 'action',
              childs: [
                'Exec',
                'Fetch',
              ],
            },
            {
              name: 'File Transfer',
              description: '',
              icon: 'file-transfer-color',
              type: 'action',
              childs: [
                'Read Single File',
                'Get List Directory',
                'Download Single File',
                'Upload',
                'Move Single File',
                'Delete Single File',
              ],
            },
          ],
        },
        {
          group_name: 'CALL & HIT',
          items: [
            {
              name: 'Function',
              description: '',
              icon: 'function-color',
              type: 'action',
              childs: [],
            },
            {
              name: 'API',
              description: '',
              icon: 'api-color',
              type: 'action',
              childs: [],
            },
            {
              name: 'Job',
              description: '',
              icon: 'job-color',
              type: 'action',
              childs: [],
            },
            {
              name: 'Dedicated Job',
              description: '',
              icon: 'dedicated-job-color',
              type: 'action',
              childs: [],
            },
          ],
        },
        {
          group_name: 'OTHERS',
          items: [
            {
              name: 'Generate File',
              description: '',
              icon: 'sheet-color',
              type: 'action',
              childs: [],
            },
            {
              name: 'Send Notification',
              description: '',
              icon: 'send-notif-color',
              type: 'action',
              childs: [
                'Email',
                'Push Notification',
              ],
            },
          ],
        },
      ],
    };
  },
  watch: {
    searchAction(val) {
      if (val && val.length >= 3) {
        let filterGroup = [];
        this.listAction.forEach((e) => {
          const dataItem = e.items.filter(f => f.name.toUpperCase().includes(val.toUpperCase()));
          if (dataItem && dataItem.length) filterGroup = dataItem;

          e.items.forEach((i) => {
            const dataChild = i.childs.filter(f => f.toUpperCase().includes(val.toUpperCase()));
            if (dataChild.length) {
              dataChild.forEach((c) => {
                filterGroup.push({
                  name: i.name,
                  description: c,
                  icon: i.icon,
                  type: i.type,
                  childs: [],
                  merge: true,
                });
              });
            }
          });
        });
        this.listActionSearch = this._.cloneDeep(filterGroup);
      } else {
        this.listActionSearch = [];
      }
    },
  },
  mounted() {
    const el = document.getElementById('list-action');
    if (el) {
      el.onscroll = async () => {
        this.listAction.forEach((e) => {
          e.items.forEach((i) => {
            if (i.childs.length) {
              const element = document.getElementById(`items-childs-${i.icon}`);
              if (element && i.name === 'Send Notification') element.style.marginTop = `-${el.scrollTop + 175}px`;
              else if (element && el.scrollTop > 50) element.style.marginTop = `-${el.scrollTop + 100}px`;
              else if (element) element.style.marginTop = `-${el.scrollTop}px`;
            }
          });
        });
      };
    }
  },
  methods: {
    ...mapMutations('jStoreAutomation', ['setDataDoAction']),

    selectActionBlock(item, childItem) {
      if (item.childs.length === 0 || childItem) {
        // eslint-disable-next-line
        const dataDo = childItem ? childItem : (item.merge ? item.description : null);
        this.setDataDoAction({ type: item.name, do: dataDo });
        this.$emit('select', {
          type: item.type,
          last_index: this.lastIndex,
          modal_ref: this.modalRef,
          position: this.position,
          row: this.row,
          data_parent: this.dataParent,
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalListAction.vue